module.exports = __webpack_public_path__ + "media/images/medium-1086ed4db7a51ce50432fbb15d9e4b80.jpg";